var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link toggle-right"},[_c('i',{staticClass:"icon toggle-right",class:_vm.isFullscreen ? 'ri-fullscreen-exit-line' : ' ri-fullscreen-line',on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }